// 5.27.3 — the ONE list of user roles for Admin › Users (Henry 2026-10-20). Both role dropdowns (the edit row and
// Add User) use RoleSelect, so they always offer the same three roles the backend accepts (UserRole: staff,
// manager, admin). RoleBadge shows the role with a capitalised label and its own colour.
import React from 'react';

export const ROLE_OPTIONS = [
  { value: 'staff', label: 'Staff' },
  { value: 'manager', label: 'Manager' },
  { value: 'admin', label: 'Admin' },
];

const BADGE = {
  admin: { background: '#FDF2F2', color: '#C0392B' },
  manager: { background: '#EEF4FD', color: '#2563EB' },
  staff: { background: '#F2FDF6', color: '#27AE60' },
};

export const roleLabel = (role) => (ROLE_OPTIONS.find((o) => o.value === role) || {}).label || role || '';

export default function RoleSelect({ value, onChange, style, ...rest }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} style={style} {...rest}>
      {ROLE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}

export function RoleBadge({ role }) {
  const c = BADGE[role] || BADGE.staff;
  return (
    <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, background: c.background, color: c.color }}>
      {roleLabel(role)}
    </span>
  );
}
